<template>
    <div>
        <headerpage :status="2"></headerpage>
        <div class="deground">
            <div class="indexpage"  >
        <div class="box" :style="{height:height+'px'}">
            <img :src="common.public_pic | addurl" style="width: 100%;height: 100%;position: absolute;top: 0;" />
            <img src="../../assets/images/qie/10.png" class="box_top_img" />
        </div>
        <div class="adaptation" style="background-color: #f6f8f7;">
            <div class="box1">
                <div class="box1_cent" v-for="item in list" @click="detailjump('detail', item.id, 5)">
                    <img :src="item.image | addurl" class="box1_img" />
                    <div style="flex: 1;margin: 0 20px;height:160px;display: flex;flex-direction: column;justify-content: space-between;">
                        <div class="box1_cent_tt1 text-cut" >{{item.title}}</div>
                        <div class="box1_cent_tt  text-cut2">{{item.content}}</div>
                        <div class="box1_cent_tt" style="font-size: 15px;">发布时间：{{item.realse_time}}</div>
                    </div>
                    <div class="box1_cent_tt" style="font-size: 15px;color: #0170c1;">阅读全文</div>
                </div>
                <div v-if="list.length==0" style="width: 100%;text-align: center;">
                    <Nomore></Nomore>
                </div>
            </div>
            <div class="box2 pagecss">
                <el-pagination
                  background
                  :page-size="pagesize"
                  :hide-on-single-page="true"
                  layout="prev, pager, next"
              
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :total="totalnum"
                >
                </el-pagination>
            </div>
            <div style="height: 40px;" v-if="list.length!==0"></div>
        </div>
         
    </div>
        </div>
 
    </div>
     
</template>
  
<script>
import windowchange from '@/util/window'
import headerpage from '../../components/header/header.vue';
import { mapGetters } from 'vuex'
import Nomore from '../../components/nomore.vue';
export default {
    mixins: [windowchange],
    components: { headerpage, Nomore },
    computed: {
        ...mapGetters({
            common: 'user/common',
        }),
    },
    data() {
        return {
            pagesize: 8,
            currentPage: 1,
            totalnum:0,
            list:[],
            height1:400
        }
    },
    methods: {
        handleCurrentChange: function (currentPage) {
            this.currentPage = currentPage;
            this.public_list();
        },
        public_list(){
            this.loading = true
            var api = this.$api.api.demo.public_list;
            this.$https.post({
                api: api,
                type: "formData",
            }, {
                page: this.currentPage,
                page_size: this.pagesize,
            }, (response) => {
                // console.log('12333333333333',response.data)
                this.totalnum = response.count;
                this.list = response.data;
                this.loading = false
            }, (error) => {
                console.log(error);
            });
        },
        detailjump(name, id, type) {
            this.$router.push({ name: name, query: { type: type, id: id } });
        },

    },
    created() {
        this.public_list();
    },
}
</script>
<style lang="scss">
.indexpage {

    .pagecss .el-pagination.is-background .btn-next,
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
        background-color: #fff;
        color: #999999;
        margin: 0 5px;

    }

    .pagecss .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #206ad9;
        border-radius: 4px;
    }

    .pagecss .el-icon-arrow-left {
        margin-right: 10px;
    }

    .pagecss .el-icon-arrow-left:before {
        content: '上一页'
    }

    .pagecss .el-icon-arrow-right {
        margin-left: 10px;
    }

    .pagecss .el-icon-arrow-right:before {
        content: '下一页'
    }
}
</style>
<style scoped >
.box {
   
    background-size: 100% 100%;
    height: 450px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.box_top_img {
    width: 905px;
    /* height: 51px; */
    position: absolute;
    top: 12%;
}

.box1 {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin: 45px 0;
    margin-bottom: 10px;
    
}

.box1_cent {
    width: 100%;
    display: flex;
    padding: 20px 0;
    margin-right: 1.33%;
    cursor: pointer;
    align-items: center;
    border-bottom: 1px solid #eee;
}

.box1_cent:nth-child(4n) {
    /* margin-right: 0; */
}

.box1_img {
    width: 220px;
    height: 180px;
    object-fit: cover;
}

.box1_cent_tt {
   
  
    font-size: 18px;
    color: #a5a5a8;

}

.box1_cent_tt1 {
    font-size: 20px;
    color: #1f1f1f;
    font-weight: 600;
    /* line-height: 32px; */
   
}

.box2 {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>


// WEBPACK FOOTER //
// servicelist.vue?590fd7ab